module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "body-text-full-out"
  }, [_c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v("Born in 1948 in Winchester, Hampshire, ")]), _c('span', {
    staticClass: "no-style-override-5"
  }, [_vm._v("Christopher Berry-Dee")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(" is descended from Dr John Dee, Court Astrologer to Queen Elizabeth I, and is the founder and former Director of the Criminology Research Institute (CRI), and former publisher and Editor-in-Chief of ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("The Criminologist")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", a highly respected journal on matters concerning all aspects of criminology from law enforcement to forensic psychology. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v("Christopher has interviewed and interrogated over thirty of the world’s most notorious killers – serial, mass and one-off – including Peter Sutcliffe, Ted Bundy, Aileen Wuornos, Dennis Nilsen and Joanne Dennehy. He was co-producer/interviewer for the acclaimed twelve-part TV documentary series ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("The Serial Killers")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", and has appeared on television as a consultant on serial homicide, and, in the series ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Born to Kill?")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", on the cases of Fred and Rose West, the ‘Moors Murderers’ and Dr Harold Shipman. He has also assisted in criminal investigations as far afield as Russia and the United States. ")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override"
  }, [_c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v("Notable book successes include: ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Monster")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(" (the basis for the movie of the same title, about Aileen Wuornos); ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Dad, Help Me Please")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", about the tragic Derek Bentley, hanged for a murder he did not commit (subsequently subject of the film ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Let Him Have It")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v("); and ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Serial Killers")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", Christopher’s international bestseller, now, with its sequel,")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v(" Talking with Serial Killers: World’s Most Evil")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", required reading at the FBI Behavioral Analysis Unit Academy at Quantico, Virginia. His ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Psychopaths and Savages: A Journey Into the Evil Mind")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", was the UK’s bestselling true-crime title of 2017; its successor volume, ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Psychopaths and Savages: Beyond Evil")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", was published in the autumn of 2019. In 2020 a new edition of his ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Serial Killers: Dead Men Talking")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(" appeared, and he has since published ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Serial Killers: Stalkers")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(", ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Psychopaths and Savages: Mass Murderers and Spree Killers")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(" and, in 2022, ")]), _c('span', {
    staticClass: "no-style-override-6"
  }, [_vm._v("Talking with Serial Killers: Sleeping with Psychopaths")]), _c('span', {
    staticClass: "no-style-override-4"
  }, [_vm._v(". He is the UK’s bestselling true-crime writer.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text body-text-override-1"
  }, [_c('span', {
    staticClass: "no-style-override-4"
  }, [_c('a', {
    attrs: {
      "href": "http://www.christopherberrydee.com",
      "target": "_blank"
    }
  }, [_vm._v("www.christopherberrydee.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-243903fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/f002.vue
// module id = 60
// module chunks = 0